import { ElementDefinition, Element } from "@easy-email-pro-core/typings";

export function createBlock<T extends Element>(
  block: ElementDefinition<T>
): ElementDefinition<T> {
  return block;
}

export function createCustomBlock<T extends Element>(
  block: ElementDefinition<T> & {
    void: boolean;
    emptyWithPlaceholder?: boolean;
  }
): ElementDefinition<T> {
  return block;
}
